import Vue from 'vue';
import Router from 'vue-router';
import BaseComponent from '@/Base';

Vue.use(Router);

const pathURL = {
    root: '/',
    notFound: '/404',
    lang: '/:lang',
    home: '',
    course: 'course',
    courseDetail: 'course/:detail',
    chapterDetail: 'course/:detail/:chapter',
    exam: 'exam',
    examRoom: 'exam/room',
    userProfile: 'user/profile',
    userCertificate: 'user/certificate',
    userAccount: 'user/account',
    userReset: 'user/reset/:token',
    payment: 'payment',
    why: 'why',
    graduates: 'graduates',
    about: 'about',
    contact: 'contact',
    term: 'term', 
    privacy: 'privacy'
};

const base =
    process.env.NODE_ENV === 'production'
        ? '/'
        : '/';

const router = new Router({
    mode: 'history',
    base,
    routes: [
        { path: '*', component: require('@/pages/404.vue').default, meta: { layout: 'blank' } },
        { path: pathURL.notFound, component: require('@/pages/404.vue').default, meta: { layout: 'blank' } },
        { path: pathURL.root, component: require('@/pages/Startup.vue').default, meta: { layout: 'blank' } },
        { 
            path: pathURL.lang, 
            component: BaseComponent,
            children: [
                { path: pathURL.home, component: () => import('@/pages/Home.vue') },
                { path: pathURL.course, component: () => import('@/pages/Course.vue') },
                { path: pathURL.courseDetail, component: () => import('@/pages/CourseDetail.vue') },
                { path: pathURL.chapterDetail, component: () => import('@/pages/ChapterDetail.vue') },
                { path: pathURL.exam, component: () => import('@/pages/Exam.vue') },
                { path: pathURL.examRoom, component: () => import('@/pages/ExamRoom.vue') },
                { path: pathURL.userProfile, component: () => import('@/pages/UserProfile.vue') },
                { path: pathURL.userCertificate, component: () => import('@/pages/UserCertificate.vue') },
                { path: pathURL.userAccount, component: () => import('@/pages/UserAccount.vue') },
                { path: pathURL.userReset, component: () => import('@/pages/UserReset.vue') },
                { path: pathURL.payment, component: () => import('@/pages/Payment.vue') },
                { path: pathURL.why, component: () => import('@/pages/Why.vue') },
                // { path: pathURL.graduates, component: () => import('@/pages/Graduates.vue') },
                { path: pathURL.about, component: () => import('@/pages/About.vue') },
                { path: pathURL.contact, component: () => import('@/pages/Contact.vue') },
                { path: pathURL.term, component: () => import('@/pages/Term.vue') },
                { path: pathURL.privacy, component: () => import('@/pages/Privacy.vue') }
            ]
        }
    ],
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    let paramLang = to.params.lang;

    if (paramLang !== 'th' && paramLang !== 'en' && to.path !== pathURL.notFound && to.path !== pathURL.root) {
        let langCode = Vue.cookie.get('defaultLang');
        let isError = true;

        if (!langCode) {
            langCode == 'th';
        }

        if (paramLang) {
            isError = false;
        }
        else {
            let pathArray = to.path.split('/');
        
            if (pathArray.length > 1) {
                paramLang = pathArray[1];

                if (paramLang !== 'th' && paramLang !== 'en') {
                    isError = false;
                }
            }
        }

        if (!isError) {
            next('/' + langCode + to.fullPath);
        }
        else {
            next(pathURL.notFound);
        }
    }
    else {
        next();
    }
});

export default router;